module.exports = __webpack_public_path__ + "static/img/robocop.1685ac3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robocop.svg
// module id = 3QzV
// module chunks = 0